// TODO HARDCODED PROGRESS PERCENTAGE
import { Progress } from 'react-sweet-progress';
import React from 'react';

export const BuilderProgressComponent = ({ percent }) => (
  <div className="no__progress__value__indicator">
    <Progress percent={99} className="builderProgressBar" />
  </div>
);
